<template>
  <div class="wrapper">
    <div class="main visual-2 /enter-phone visual-12">
      <Header backRoute="/enter-telephone" />

      <!-- ✅ Loader Overlay -->
      <div v-if="isLoading" class="loader-overlay">
        <div class="loader"></div>
        <p>Please wait, checking you in...</p>
      </div>

      <div class="vis4-inr1" v-else>
        <h1>Best Form of<br />Communication?</h1>

        <!-- When clicking on any option, email or text, store the choice in localStorage -->
        <div class="formss">
          <h3 @click="setCommunicationType('email')">Email</h3>
          <h4 @click="setCommunicationType('text')">Text</h4>
        </div>
      </div>

      <FooterView />
    </div>
  </div>
</template>

<script>
import { AppointmentService } from "@/services/appointments.service";
import { PatientTimeSlotsService } from "@/services/patient-time-slots.service";
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
import { lowercaseString } from "@/utils/helpers";

export default {
  components: { FooterView, Header },
  name: "CommunicationType",
  data() {
    return {
      isLoading: false, // ✅ controls the loader visibility
    };
  },
  mounted() {
    const patient = JSON.parse(localStorage.getItem("patient"));

    // Normal flow validation
    if (!this.$route.query.code && !patient?.email) {
      this.$router.push("/available-doctor");
    }
  },
  methods: {
    async handleAppointmentCheckIn(code) {
      this.isLoading = true;
      try {
        // 1️⃣ Get appointment details by code
        const response = await AppointmentService.getByCode(code);
        if (!response.success) {
          this.$store.commit("toast/NEW", {
            type: "error",
            message: response.message || "Invalid appointment code.",
          });
          this.$router.push("/appointments");
          return;
        }

        const appointment = response.data?.appointment;
        if (!appointment) {
          this.$store.commit("toast/NEW", {
            type: "error",
            message: "Appointment not found.",
          });
          return;
        }

        // 2️⃣ Get patient info from localStorage
        const patient = JSON.parse(localStorage.getItem("patient")) || {};

        // 3️⃣ Prepare payload
        const payload = {
          firstname: patient.firstname,
          lastname: patient.lastname,
          email: lowercaseString(patient.email) || null,
          phoneNumber: patient.phone || null,
          address: patient.address || "Not provided",
          communicationType: patient.communicationType || "app",
          doctorSlotId: appointment.doctorSlotId,
        };

        // 4️⃣ Create patient time slot
        const createRes = await PatientTimeSlotsService.create(payload);
        if (createRes.success) {
          localStorage.removeItem("patient");

          // 5️⃣ Redirect to Appointment Status
          this.$router.push({
            path: "/appointment-status",
            query: { id: createRes.data.id },
          });
        } else {
          this.$store.commit("toast/NEW", {
            type: "error",
            message: createRes.message || "Failed to create patient timeslot.",
          });
        }
      } catch (error) {
        console.error("Error in handleAppointmentCheckIn:", error);
        this.$store.commit("toast/NEW", {
          type: "error",
          message: "Something went wrong while checking in.",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async setCommunicationType(type) {
      const patient = JSON.parse(localStorage.getItem("patient")) || {};
      patient.communicationType = type;
      localStorage.setItem("patient", JSON.stringify(patient));

      // ✅ Show loader when appointment flow starts
      if (this.$route.query.code) {
        await this.handleAppointmentCheckIn(this.$route.query.code);
      } else {
        this.$router.push("/available-doctor");
      }
    },
  },
};
</script>

<style scoped>
.formss {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.formss h3,
.formss h4 {
  margin: 10px;
  transition: color 0.3s;
}

.formss h3:hover,
.formss h4:hover {
  color: #afc7e1;
}

/* ✅ Loader overlay styling (non-intrusive, centered) */
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loader-overlay p {
  font-size: 18px;
  color: #333;
  margin-top: 10px;
}
</style>
